import { render, staticRenderFns } from "./VChipFormat.vue?vue&type=template&id=23a6fc41&"
import script from "./VChipFormat.vue?vue&type=script&lang=js&"
export * from "./VChipFormat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports